module.exports = __webpack_public_path__ + "img/cloud (2).a6fbe2d3.png";